import { render, staticRenderFns } from "./LifeStageInfo.vue?vue&type=template&id=38a4f9a0&scoped=true&"
import script from "./LifeStageInfo.vue?vue&type=script&lang=js&"
export * from "./LifeStageInfo.vue?vue&type=script&lang=js&"
import style0 from "./LifeStageInfo.vue?vue&type=style&index=0&id=38a4f9a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a4f9a0",
  null
  
)

export default component.exports